import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import {
  tablerArrowLeft,
  tablerBell,
  tablerMenu2,
  tablerPlus,
  tablerSearch,
  tablerUser,
  tablerUserCircle,
  tablerX,
  tablerDots,
} from '@ng-icons/tabler-icons';
import { ActionItemComponent } from './action-item.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AudioPlayerComponent } from './audio-player';
import { PostDto } from '@oracychampions/api-interfaces';
import { LevelsComponent } from './levels.component';
import { Game } from '../core/game';

@Component({
  selector: 'oc-post',
  standalone: true,
  imports: [
    CommonModule,
    NgIconComponent,
    ActionItemComponent,
    NgbDropdownModule,
    AudioPlayerComponent,
    LevelsComponent,
  ],
  providers: [
    provideIcons({
      tablerSearch,
      tablerBell,
      tablerUserCircle,
      tablerMenu2,
      tablerArrowLeft,
      tablerX,
      tablerPlus,
      tablerUser,
      tablerDots,
    }),
  ],
  template: ` <div *ngIf="post" class="oc-post" [class.oc-post-compact]="compact">
    <div class="oc-post-main">
      <div class="oc-post-player">
        <oc-audio-player [src]="post.audioURL" (time)="currentTime($event)"></oc-audio-player>
      </div>
      <div class="oc-card-title">
        <div class="oc-post-pills">
          <div class="oc-post-pills-students">
            <span *ngFor="let student of post.students" class="badge bg-secondary">{{ student.name }}</span>
          </div>
          <div class="oc-card-game">
            <span class="badge bg-secondary" [class.badge]="!compact" [class.bg-secondary]="!compact">
              <ng-container *ngIf="post.game === Game.None">Post</ng-container>
              <ng-container *ngIf="post.game === Game.YesNo">YesNo Game</ng-container>
              <ng-container *ngIf="post.game === Game.Debate">Debate</ng-container>
              <ng-container *ngIf="post.game === Game.Picture">Say It, See It</ng-container>
            </span>
          </div>
        </div>
        <div *ngIf="!compact" class="oc-card-maintitle">{{ post.title }}</div>
      </div>
      <div *ngIf="actions.length" class="oc-card-actions" ngbDropdown>
        <oc-action-item icon="tablerDots" ngbDropdownToggle class="oc-post-menu-btn" size="sm"></oc-action-item>
        <div ngbDropdownMenu>
          <button *ngFor="let action of actions" ngbDropdownItem (click)="action.action()">{{ action.title }}</button>
        </div>
      </div>
    </div>
    <div *ngIf="!compact" class="oc-post-levels">
      <oc-levels [levels]="levels" [progress]="time"></oc-levels>
    </div>
  </div>`,
  styles: `
  .oc-post {
    display: flex;
    flex-direction: column;
    background: white;
    border-radius: 0.65rem;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;

    .oc-post-levels {
      margin-left: 1rem;
      margin-top: -0.5rem;
    }

    &.oc-post-compact {
      height: 200px;

      .oc-post-main {
        flex-direction: column;
        padding: 0.25rem 0.85rem;

        .oc-post-player {
          margin-inline: auto;
          margin-top: 0.3rem;
          padding: 1.35rem;
        }

        .oc-card-title {
          flex-direction: column;
          
          width: 100%;
          margin: 0;

          .oc-post-pills-students {
            justify-content: center;
            width: 100%;
            order: 1;
            flex-wrap: wrap;
          }

          .oc-card-game {
            padding: 0;
            order: 0;
            line-height: 1.5;
          }
        }

        .oc-post-pills {
          flex-direction: column;
          width: 100%;
          gap: 10px;
        }

        .oc-card-actions {
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }
  }

  .oc-post-main {
    display: flex;
    position: relative;
    padding: 0.15rem 0.25rem;
    align-items: start;

    .oc-post-player {
      padding: 1rem;
    }

    .oc-card-icon {
      height: 30px;
    }

    .oc-card-title {
      overflow: hidden;
      flex: 1;
      margin-top: 1rem;
    }

    .oc-card-maintitle {
      font-size: 1.2rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .dropdown-toggle::after {
      display: none;
    }

    .badge {
      color: #444;
    }

    .oc-post-pills {
      display: flex;
      align-items:center;
      justify-content: space-between;
      line-height: 0;

      .oc-post-pills-students {
        display: flex;
        gap: 4px;
      }
    }

    // .oc-post-menu-btn {
    //   // transform: scale(0.85);
    //   display: block;
    //   position:relative;
    //   top: -5px;
    //   right: -5px;
    // }
  }

  .oc-card-game {
    padding-right: 0.5rem;
  }
  `,
})
export class PostComponent {
  @Input() post: PostDto | null = null;
  @Input() audioSrc = '';
  @Input() actions: any[] = [];
  @Input() compact = false;

  time = 0;

  Game = Game;

  get levels() {
    return this.post?.levels ? JSON.parse(this.post.levels) : [];
  }

  currentTime(time: number) {
    this.time = time;
  }
}
